import React, { Dispatch, SetStateAction } from 'react';
import { createUseStyles } from 'react-jss';
import EmptyBankDetail from '../../../assets/icons/emptyBankDetails.svg';
import { FormikProps } from 'formik';
import { IStatutoryDetailProps } from './StatutoryDetail.template';
import ButtonV2 from '../../atoms/ButtonV2';

interface IEmptyBankDetailsTemplate {
    setEdit: Dispatch<SetStateAction<boolean>>
}
const useStyles = createUseStyles((theme: any) => ({
    container: {
        border: `1px solid ${theme.palette.border.secondaryLightAccent}`
    },
    heading: {
        color: theme.palette.textV2.secondary.secondary800,
    }
}));

const EmptyBankDetailsTemplate: React.FC<IEmptyBankDetailsTemplate> = ({ setEdit }) => {
    const classes = useStyles();
    return (
        <div className={`${classes.container} py-14 px-6  rounded-lg`}>
            <div className='grid gap-y-4'>
                <div className='grid gap-y-8 justify-items-stretch'>
                    <div className='justify-self-center'>
                        <img src={EmptyBankDetail} alt="emptyBankDetailImage" className="" />
                    </div>
                    <div className={`justify-self-center font-normal text-lg ${classes.heading}`}>
                        You haven't provided Bank Details for your business.
                    </div>
                </div>
                <div className='grid justify-items-stretch'>
                    <ButtonV2
                        className={` justify-self-center w-auto`}
                        variant="contained"
                        label="Upload Bank Details"
                        onClick={() => { setEdit(true)}}
                    />
                </div>
            </div>
        </div>
    )
};
export default EmptyBankDetailsTemplate;
